// Campus photo for /colleges/ohio-state-university: CC BY-SA 4.0, by Michael Barera, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AThe_Ohio_State_University_June_2013_24_(The_Oval_and_Thompson_Library).jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/ohio-state-university/; credited under the photo.
const photo = {
    "slug": "ohio-state-university",
    "alt": "Thompson Library and the William Oxley Thompson statue on the Oval at The Ohio State University in Columbus, Ohio",
    "src": "/colleges/ohio-state-university/campus-1600.webp",
    "srcSmall": "/colleges/ohio-state-university/campus-800.webp",
    "srcMid": "/colleges/ohio-state-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/ohio-state-university/og.jpg",
    "title": "The Ohio State University June 2013 24 (The Oval and Thompson Library)",
    "author": "Michael Barera",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AThe_Ohio_State_University_June_2013_24_(The_Oval_and_Thompson_Library).jpg",
    "read": "2026-10-01"
};

export default photo;
